export const courses = [
    {
        id: 0,
        img: "images/studentsViewing/courses/course0.png",
        title: "Complete Linux Training Course to Get Your Dream IT Job 2022",
        desc:"Imran Afzal",
        rateScore:4.6,
        reviewerNum:"128,636",
        price:129.99,
        onSale: true,
        onSalePrice:99.99,
        mark: "Bestseller"
  
    },
    {
        id: 1,
        img: "images/studentsViewing/courses/course1.png",
        title: "The Complete JavaScript Course 2022: From Zero to Expert",
        desc:"Jonas Schemedtmann",
        rateScore:4.7,
        reviewerNum:"128,636",
        price:199.99,
        onSale: false,
        mark: "Bestseller"

    },
    {
        id: 2,
        img: "images/studentsViewing/courses/course2.png",
        title: "Microsoft Excel - Excel from Beginner to Advanced ",
        desc:"Kyle Pew, Office Newb",
        rateScore:4,
        reviewerNum:"285,191",
        price:149.99,
        onSale: false,
 
    },
    {
        id: 3,
        img: "images/studentsViewing/courses/course3.png",
        title: "The Complete Digital Marketing Course - 12 Courses in 1",
        desc:"Rob Percival, Daraph Walsh, Codestars by Rob Percival",
        rateScore:4.5,
        reviewerNum:"154,729",
        price:179.99,
        onSale: false,
        mark: "Bestseller"
    },
    {
        id: 4,
        img: "images/studentsViewing/courses/course4.png",
        title: "Learn Ethical Hacking From Scratch",
        desc:"Zaid Sabih, z Security",
        rateScore:4.6,
        reviewerNum:"102,409",
        price:139.99,
        onSale: false,
        mark: "Bestseller"
    },
    {
        id: 5,
        img: "images/studentsViewing/courses/course5.png",
        title: "The Ultimate MySQL Bootcamp: Go from SQL Beginner to Expert",
        desc:"Colt Steele, lan Schoononver",
        rateScore:4.6,
        reviewerNum:"64,376",
        price:119.99,
        onSale: false,
        mark: "Bestseller"
    },
    {
        id: 6,
        img: "images/studentsViewing/courses/course6.png",
        title: " Microsoft Excel - Advanced Excel Formulas & Functions",
        desc:"Maven Analytics",
        rateScore:3.6,
        reviewerNum:"64,376",
        price:109.99,
        onSale: true,
        onSalePrice:79.99,

    },
  ];
 

  export const sugestedCourses = [
    {
        id: 0,
        img: "images/studentsViewing/suggestedCourses/sc0.png",
        title: "Ultimate AWS Certified Solutions Architect Associate 2022",
        desc:"Stephane Maarek | AWS Certified Cloud Practitioner,Solutions Architect,Developer",
        rateScore:3.5,
        reviewerNum:"261",
        price:44.99,
        onSale: false,
        mark: ""
  
    },
    {
      id: 1,
      img: "images/studentsViewing/suggestedCourses/sc1.png",
      title: "Red Team Ethical Hacking - Beginner",
      desc:"Chris Siles",
      rateScore:4.3,
      reviewerNum:"261",
      price:44.99,
      onSale: false,
      mark: "Bestseller"

    },
    {
        id: 2,
        img: "images/studentsViewing/suggestedCourses/sc2.png",
        title: "Cross-Site Scripting(XSS): The Practical Guide ",
        desc:"Christophe Limpalair, Cybr Training",
        rateScore:4.4,
        reviewerNum:"142",
        price:24.99,
        onSale: false,
        mark: "Bestseller"
    },
    {
        id: 3,
        img: "789",
        title: "Modern Ethical Hacking - Complete Course",
        img: "images/studentsViewing/suggestedCourses/sc3.png",
        desc:"Vonnie Hudson",
        rateScore:4,
        reviewerNum:"35",
        price:119.99,
        onSale: true,
        onSalePrice:89.99,
        mark: ""
    },
    {
        id: 4,
        img: "images/studentsViewing/suggestedCourses/sc4.png",
        title: "Ethical Hacking + Website Hacking + Mobile Hacking v2.0",
        desc:"Shubham Pareek",
        rateScore:4.3,
        reviewerNum:"44",
        price:54.99,
        onSale: false,
        mark: "Bestseller"
    },
    {
        id: 5,
        img: "images/studentsViewing/suggestedCourses/sc5.png",
        title: "Learn Android Hacking For Beginners",
        desc:"Colt Steele, lan Schoononver",
        rateScore:3,
        reviewerNum:"344",
        price:24.99,
        onSale: false,
        mark: ""
    },
    {
        id: 6,
        img: "images/studentsViewing/suggestedCourses/sc6.png",
        title: "The Web Developer Bootcamp 2022",
        desc:"Colt Steele",
        rateScore:4,
        reviewerNum:"344",
        price:139.99,
        onSale: true,
        onSalePrice:79.99,
        mark: ""
    },
  ];

